
import React, { useState } from "react";
import { useSpring, animated } from "react-spring";
import "./card.css";

function Card({ image, cardTitle, cardContent, bkColor }) {
  const [show, setShown] = useState(false);

  const props3 = useSpring({
    backgroundImage: bkColor,
    transform: show ? "scale(1.03)" : "scale(1)",
    boxShadow: show
      ? "0 20px 25px rgb(0 0 0 / 25%)"
      : "0 2px 10px rgb(0 0 0 / 8%)"
  });
  return (
    <animated.div
      className="card"
      style={props3}
      onMouseEnter={() => setShown(true)}
      onMouseLeave={() => setShown(false)}
    >
      <img src={image} alt="" />
      <h2>{cardTitle}</h2>
      <p>{cardContent}</p>

    </animated.div>
  );
}

export default Card;